import type { Keyed } from "~/types";

export function arrayToKeyed<T>(arr: T[], key: keyof T): Keyed<T> {
  const resultObject: Keyed<T> = {};
  for (const item of arr) {
    resultObject[item[key] as string] = item;
  }
  return resultObject;
}
